<div class="container main boldLis" id="skrollr-body">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <h1 class="about">{{ 'termsPage.title' | translate }}</h1>
    <ol class="terms-ol">
      <li>
      <b>{{ 'termsPage.introduction.heading' | translate }}</b>
      <p>{{ 'termsPage.introduction.para1' | translate }}</p>
      <p>{{ 'termsPage.introduction.para2' | translate }}</p>
      <p>{{ 'termsPage.introduction.para3' | translate }}</p>
      <p>{{ 'termsPage.introduction.para4' | translate }}</p>
      <p>{{ 'termsPage.introduction.para5' | translate }}</p>
    </li>
  
    <li>
    <b>{{ 'termsPage.program.heading' | translate }}</b>
    <p>{{ 'termsPage.program.para1' | translate }}</p>
    <ul class="program-list">
      <li>
        <p [innerHTML]="'termsPage.program.li1' | translate"></p>
        <p>{{ 'termsPage.program.li1Para2' | translate }}</p>
      </li>
      <li>
        <p [innerHTML]="'termsPage.program.li2' | translate"></p>
        <p>{{ 'termsPage.program.li2Para2' | translate }}</p>
        <p>{{ 'termsPage.program.li2Para3' | translate }}</p>
      </li>
    </ul>
    <p>{{ 'termsPage.program.para2' | translate }}</p>
    <p class="indented-note" [innerHTML]="'termsPage.program.para3' | translate"></p>
    <p class="indented-note">{{ 'termsPage.program.para4' | translate }}</p>
    <p class="indented-note">{{ 'termsPage.program.para5' | translate }}</p>
    </li>

    <li>
    <b>{{ 'termsPage.limitedLicense.heading' | translate }}</b>
    <p>{{ 'termsPage.limitedLicense.para1' | translate }}</p>
    <ol class="nonBoldLis" type="a">
      <li>{{ 'termsPage.limitedLicense.li1' | translate }}</li>
      <li>{{ 'termsPage.limitedLicense.li2' | translate }}</li>
    </ol>
    <p>{{ 'termsPage.limitedLicense.para2' | translate }}</p>

    <p>{{ 'termsPage.limitedLicense.para3' | translate }}</p>
    <ul>
      <li>{{ 'termsPage.limitedLicense.li3' | translate }}</li>
      <li>{{ 'termsPage.limitedLicense.li4' | translate }}</li>
      <li>{{ 'termsPage.limitedLicense.li5' | translate }}</li>
      <li>{{ 'termsPage.limitedLicense.li6' | translate }}</li>
    </ul>
    <p>{{ 'termsPage.limitedLicense.para4' | translate }}</p>
    <ul>
      <li>{{ 'termsPage.limitedLicense.li7' | translate }}</li>
      <li>{{ 'termsPage.limitedLicense.li8' | translate }}</li>
    </ul>
  </li>

  <li>
    <b>{{ 'termsPage.digitalExperience.heading' | translate }}</b>
    <h4><b><em>{{ 'termsPage.digitalExperience.createAccountsHeading' | translate }}</em></b></h4>
    <p>{{ 'termsPage.digitalExperience.para1' | translate }}</p>
    <p>{{ 'termsPage.digitalExperience.para2' | translate }}</p>
    <h4><b><em>{{ 'termsPage.digitalExperience.studentAccountsHeading' | translate }}</em></b></h4>
    <p>{{ 'termsPage.digitalExperience.para3' | translate }}</p>
    <p>{{ 'termsPage.digitalExperience.para4' | translate }}</p>
    <h4><b><em>{{ 'termsPage.digitalExperience.costHeading' | translate }}</em></b></h4>
    <p>{{ 'termsPage.digitalExperience.para5' | translate }}</p>
    <h4><b><em>{{ 'termsPage.digitalExperience.functionalityHeading' | translate }}</em></b></h4>
    <p>{{ 'termsPage.digitalExperience.para6' | translate }}</p>
    <h4><b><em>{{ 'termsPage.digitalExperience.dataSharingHeading' | translate }}</em></b></h4>
    <p>{{ 'termsPage.digitalExperience.para7' | translate }}</p>
    <p>{{ 'termsPage.digitalExperience.para8' | translate }}</p>
    <p>{{ 'termsPage.digitalExperience.para9' | translate }}</p>
    <h4><b><em>{{ 'termsPage.digitalExperience.communicationHeading' | translate }}</em></b></h4>
    <p>{{ 'termsPage.digitalExperience.para10' | translate }}</p>
    </li>

    <li>
      <b>{{ 'termsPage.paperBasedExperience.heading' | translate }}</b>
      <h4><b><em>{{ 'termsPage.paperBasedExperience.orderingMaterialsHeading' | translate }}</em></b></h4>
      <p>{{ 'termsPage.paperBasedExperience.para1' | translate }}</p>
    </li>

      <li>
      <b>{{ 'termsPage.intellectualProperty.heading' | translate }}</b>
      <p>{{ 'termsPage.intellectualProperty.para1' | translate }}</p>
      <p>{{ 'termsPage.intellectualProperty.para2' | translate }}</p>
    </li>
    <li>
      <b>{{ 'termsPage.copyrightNotice.heading' | translate }}</b>
      <p>{{ 'termsPage.copyrightNotice.para1' | translate }}</p>
      <p [innerHTML]="'termsPage.copyrightNotice.para2' | translate"></p>
    </li>
    <li>
      <b>{{ 'termsPage.thirdPartyContent.heading' | translate }}</b>
      <p>{{ 'termsPage.thirdPartyContent.para1' | translate }}</p>
    </li>

    <li>
    <b>{{ 'termsPage.termination.heading' | translate }}</b>
    <p>{{ 'termsPage.termination.para1' | translate }}</p>
    </li>

    <li>
    <b>{{ 'termsPage.warrantyDisclaimers.heading' | translate }}</b>
    <p>{{ 'termsPage.warrantyDisclaimers.para1' | translate }}</p>
    <p>{{ 'termsPage.warrantyDisclaimers.para2' | translate }}</p>
    <p>{{ 'termsPage.warrantyDisclaimers.para3' | translate }}</p>
    <p>{{ 'termsPage.warrantyDisclaimers.para4' | translate }}</p>
    <p>{{ 'termsPage.warrantyDisclaimers.para5' | translate }}</p>
    </li>

    <li>
    <b>{{ 'termsPage.liabilityIndemnity.heading' | translate }}</b>
    <p>{{ 'termsPage.liabilityIndemnity.para1' | translate }}</p>
    <p>{{ 'termsPage.liabilityIndemnity.para2' | translate }}</p>
    <p>{{ 'termsPage.liabilityIndemnity.para3' | translate }}</p>
    </li>

    <li>
    <b>{{ 'termsPage.integrationSeverability.heading' | translate }}</b>
    <p>{{ 'termsPage.integrationSeverability.para1' | translate }}</p>
    <p>{{ 'termsPage.integrationSeverability.para2' | translate }}</p>
    </li>

    <li>
    <b>{{ 'termsPage.applicableLaw.heading' | translate }}</b>
    <p>{{ 'termsPage.applicableLaw.para1' | translate }}</p>
    </li>
  </ol>

    <p><b>{{ 'termsPage.updatedDate' | translate }}</b></p>
  </div>
</div>